import { Component, Inject, NgZone, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { StorageApiService } from 'src/app/api/services/storage-api.service';
import {
  StorageFile,
  StorageUtilsService,
} from '../../services/storage-utils.service';
import { ListItem } from 'src/app/components/scrolling-list';
import { NOT_ALLOWED_FILE_NAMES } from 'src/app/api/services/storage-api.service';

@Component({
  selector: 'new-folder-modal',
  templateUrl: './new-folder-modal.component.html',
  styleUrls: ['./new-folder-modal.component.scss'],
  standalone: false,
})
export class NewFolderModalComponent implements OnInit {
  folderName = '';

  folderPath = '';
  existingFiles: ListItem<StorageFile>[] = [];

  duplicateFolderSpecified = false;
  notAllowedFileNameSpecified = false;
  waitingForResponse = false;
  serverError = false;
  accessDenied = false;
  accessDeniedMessage = '';
  respCode: number;

  constructor(
    public dialogRef: MatDialogRef<NewFolderModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: NewFolderModalData,
    private storageApiService: StorageApiService,
    private ngZone: NgZone,
  ) {
    this.folderPath = data.folderPath;
    this.existingFiles = data.existingFiles;
  }

  ngOnInit(): void {
    // Initialize component in NgZone to help with focus timing
    this.ngZone.run(() => {});
  }

  private _fileNameExists(fileName: string) {
    for (let i = 0; i < this.existingFiles.length; i++) {
      if (
        this.existingFiles[i].item.name === `${this.folderPath}${fileName}/`
      ) {
        return true;
      }
    }
    return false;
  }
  private _notAllowedFileName(fileName: string) {
    return NOT_ALLOWED_FILE_NAMES.includes(fileName);
  }

  ok() {
    if (!this.folderName) {
      this.folderName = '';
    }
    this.folderName = this.folderName.replace(/\//g, '');
    if (this._notAllowedFileName(this.folderName)) {
      this.notAllowedFileNameSpecified = true;
      return;
    }
    if (this._fileNameExists(this.folderName)) {
      this.duplicateFolderSpecified = true;
      return;
    }
    if (this.folderName !== '') {
      this.waitingForResponse = true;

      this.storageApiService
        .createFolder(this.folderPath + this.folderName)
        .then((resp) => {
          if (resp.code === 200) {
            this.dialogRef.close(this.folderName);
          } else if (
            resp.code === 403 &&
            resp.message.indexOf('restricted-role') === -1
          ) {
            this.accessDenied = true;
            this.accessDeniedMessage =
              StorageUtilsService.STORAGE_CLIENT_ERROR[resp.message];
          } else if (resp.code === 403) {
            this.accessDenied = true;
          } else {
            this.respCode = resp.code;
            this.serverError = true;
          }
        })
        .finally(() => {
          this.waitingForResponse = false;
        });
    }
  }

  cancel() {
    this.dialogRef.close(false);
  }
}

interface NewFolderModalData {
  folderPath: string;
  existingFiles: ListItem<StorageFile>[];
}
